import { useState } from 'react';
import { Box, Button, TextField, Typography, Paper } from '@mui/material';
import emailjs from 'emailjs-com';

const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userId = process.env.REACT_APP_EMAILJS_USER_ID; // public/user ID

    emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);

    const templateParams = {
      from_name: form.name,
      from_email: form.email,
      message: form.message,
    };

    try {
      await emailjs.send(serviceId, templateId, templateParams, userId);
      setSubmitted(true);
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      console.error('EmailJS error:', err);
      setError('Hubo un error al enviar el mensaje. Intenta de nuevo o haz click en el email para contactarnos directamente.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ backgroundColor: 'beige',  maxWidth: 800, mx: 'auto', mt: 7, p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <Typography variant="h5" gutterBottom sx={{ color: '#0000FF', textAlign: 'center' }}>
        Contact Us <br />
        <a
          href="mailto:contacto@timelinestudio.es"
          style={{ color: '#0000FF', textDecoration: 'none', fontSize: '12px' }}
        >
          contacto@timelinestudio.es
        </a>
      </Typography>
      {submitted ? (
        <Typography color="success.main">¡Gracias por tu mensaje!</Typography>
      ) : (
        <Box component="form" onSubmit={handleSubmit} sx={{ backgroundColor: 'beige',display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Nombre"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            variant="outlined"
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            variant="outlined"
          />
          <TextField
            label="Mensaje"
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            multiline
            rows={4}
            variant="outlined"
          />
          <Button type="submit" variant="contained" color="primary" disabled={sending}>
            {sending ? 'Enviando...' : 'Enviar'}
          </Button>
          {error && <Typography color="error.main">{error}</Typography>}
        </Box>
      )}
    </Paper>
  );
};

export default ContactForm;